module.exports = __webpack_public_path__ + "img/tool.3d96b5f2.png";